import {createSlice} from "@reduxjs/toolkit";
import {Room} from "../../models/Room";
/**
 * Room Slice
 * - Takes in room objects in db format
 * - Stores room objects in frontend format
 * - stores data as dict of dict:
 * data: { roomId1: {Room obj 1},
 *         roomId2: {Room obj 2},
 *         ...
 *       }
 */
const initialState = {
  loading: false,
  data: {},
  error: "",
};

const roomSlice = createSlice({
  name: "room",
  initialState,

  reducers: {
    addRoom: (state, action) => {
      let newRoom = {
        roomId: action.payload.roomId,
        floor: action.payload.floor,
        roomName: action.payload.roomName,
        buildingId: action.payload.buildingId,
        nanoId: action.payload.nanoId,
      };
      state.data[action.payload.roomId] = newRoom;
    },
    updateRoom: (state, action) => {
      let rid = action.payload.roomId;
      state.data[rid].floor = action.payload.floor;
      state.data[rid].roomName = action.payload.roomName;
      state.data[rid].buildingId = action.payload.buildingId;
      state.data[rid].nanoId = action.payload.nanoId;
    },
    removeNanoFromRoom: (state, action) => {
      let rid = action.payload.roomId;
      state.data[rid].nanoId = "";
    },

    deleteRoom: (state, action) => {
      const key = action.payload.roomId;
      delete state.data[key];
    },
    setRoom: (state, action) => {
      let roomList = action.payload;
      let roomDict = {};
      for (let room of roomList) {
        room = JSON.parse(JSON.stringify(new Room(room)));
        roomDict[room.roomId] = room;
      }
      state.data = roomDict;
    },
  },
});

export const {
  setRoom,
  addRoom,
  updateRoom,
  deleteRoom,
  updateRoomCurrCount,
  updateRoomCumulativeCount,
  removeNanoFromRoom,
} = roomSlice.actions;

export default roomSlice.reducer;
